import { ArrowDownRight } from 'lucide-react';
import { experience } from '../../data/siteContent';
import { useApp } from '../../context/AppContext';
import { Reveal } from '../ui/Reveal';
import { SectionHeading } from '../ui/SectionHeading';

// The career timeline keeps every role readable while revealing extra context on hover.
export function Experience() {
  const { language, t } = useApp();

  return (
    <section id="experience" className="experience-section section-pad">
      <div className="page-shell experience-grid">
        <div className="experience-intro">
          <SectionHeading kicker={t.experience.kicker} title={t.experience.title} intro={t.experience.intro} />
          <div className="experience-marker" aria-hidden="true">
            <span>2015</span><i /><span>NOW</span>
          </div>
        </div>

        <div className="timeline">
          {experience.map((job, index) => (
            <Reveal delay={index * 0.035} key={`${job.company}-${job.period}`}>
              <article className="timeline-item">
                <div className="timeline-item__number">0{index + 1}</div>
                <div className="timeline-item__content">
                  <p className="timeline-item__period">{job.period}</p>
                  <h3>{job.role[language]}</h3>
                  <p className="timeline-item__company">{job.company}</p>
                  <p className="timeline-item__detail">{job.detail[language]}</p>
                </div>
                <ArrowDownRight className="timeline-item__arrow" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
